// ../../Functions.js/Foiling.js
import { foilcostlist, platecost } from "../Pages/Est/Calcs";

/**
 * Calculates foiling-specific costs (foil stamping die/plate)
 * Uses the same platecost lookup table but with +1" on both dimensions (standard in foil dies)
 * Returns updated item with .foil object containing accurate plate cost
 */
export function calculateFoilingCost(item, length, width, foilmr, currentPlateCostOverride = null) {
  // Add 1 inch to both dimensions — industry standard for foil stamping dies


  const w = (parseFloat(width) || 0) + 1;  //6
  const l = (parseFloat(length) || 0) + 2;  //10
  const squareinch = w * l;

  const originalrollLength = 12000
  const originalrollWidth = 24
const originalrollCost = 93.00


const mat = 1.30
const lab = 1.15

const tempW = Math.floor(originalrollWidth / w) // 4
const tempL = Math.floor(originalrollLength / l) // 1200
const totalrollPieces = tempW * tempL 
const temprollCost = (originalrollCost / (tempL * tempW)) * mat



  // Always work on a fresh copy to avoid mutating original
  const newItem = { ...item };

  // Initialize .foil object if missing
  if (!newItem.foil) {
    newItem.foil = {
      state: true,
      width: 0,
      length: 0,
      platecost: 0,
      foilmr: 50,
      dieSize: ''
    };
  }

  // If no size entered, keep zero cost
  if (squareinch <= 0 || !width || !length) {
    newItem.foil.platecost = 0;
    newItem.foil.dieSize = '';
    return newItem;
  }

  // Lookup exact match in platecost table (your existing Calcs data)
  const plate = platecost.find(p => p.squareinch === squareinch);

  const calculatedPlateCost = plate ? parseFloat(plate.cost) * mat : 0;

  // Use override only if explicitly passed (from manual input), otherwise use calculated
  const finalPlateCost = currentPlateCostOverride !== null && currentPlateCostOverride !== undefined
    ? parseFloat(currentPlateCostOverride * mat)
    : calculatedPlateCost;

  // Update foil data
      console.log(newItem);
  newItem.foil.width = parseFloat(width) || 0;
  newItem.foil.length = parseFloat(length) || 0;
  newItem.foil.platecost = finalPlateCost;
newItem.foil.foilmr = ((parseFloat(foilmr) || 50) * lab);
  newItem.foil.dieSize = `${w.toFixed(1)}×${l.toFixed(1)} in`;
  newItem.foil.foilcost = temprollCost * parseInt(item.quantity);



  return newItem;
}